import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../hooks/useAuth';
import { LevelEntitiesTable } from '../../pages/platform/tenants/levels/LevelEntitiesTable';

/**
 * DEC-032: Gestión de "grupos" (LEVEL_1) en el CONTEXTO PROPIO del tenant (`/tenant/groups`). Espejo tenant-side
 * de la pestaña de niveles del drill-down platform (`/platform/tenants/{id}/levels/LEVEL_1`), para que un
 * admin logueado como tenant (isPlatform=false, sin acceso al módulo Platform) pueda ver/crear grupos.
 *
 * Simplificación deliberada (el tenant-context NO tiene `getTenant` ni la lista de `levels[]` con sus
 * displayNames — `/me/profile` solo expone `externalScopeLevels`): la pantalla se fija en LEVEL_1 y usa
 * el label i18n "Grupos". La app del tenant `agents` tiene un único nivel, así que alcanza. Cuando el
 * backend exponga `levels[]` en `/me/profile` (follow-up, espejo de DEC-RBAC-027), esto se generaliza a
 * un item por nivel con su displayName real. Ver TD-WEBAPP-034.
 *
 * - `tenantId` = el del actor (`user.tenantId`), NO un path param (esto es el tenant propio).
 * - `requireExternalId` se deriva de `externalScopeLevels` del propio tenant (DEC-RBAC-027): si LEVEL_1
 *   es BYOID, el form de alta pide el `id` externo (mismo criterio que el drill-down platform).
 */
export const Route = createFileRoute('/_authenticated/_layout/tenant/groups')({
    component: TenantGroups,
});

function TenantGroups() {
    const { user, externalScopeLevels } = useAuth();
    const { t } = useTranslation(['common']);

    // El layout _authenticated ya garantiza sesión; guarda defensiva por si el store aún no hidrató.
    if (!user) return null;

    return (
        <LevelEntitiesTable
            tenantId={user.tenantId}
            level="LEVEL_1"
            levelDisplayName={t('common:nav.tenant.groups')}
            requireExternalId={externalScopeLevels.includes('LEVEL_1')}
        />
    );
}
